import styled from 'styled-components'

export const IconContainerProd = styled.div`
  display: flex;
  flex-wrap: wrap;
`